module.exports = __webpack_public_path__ + "img/logo-mobile.e1c41b21.svg";